export const occupancyOptions = [
    { value: 'full', label: 'Full' },
    { value: 'empty', label: 'Empty' },
    { value: 'many_seats_available', label: 'Many' },
    { value: 'few_seats_available', label: 'Few' },
    { value: 'standing_room_only', label: 'Standing' },
];
